<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <div class="grid grid-cols-12 gap-4 mx-1 my-2" v-if="mode === 'THREAD'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4" v-for="(message, idx) in messages" :key="idx">
            <div class="col-span-8 py-2 rounded-md bg-gray-50 my-2 text-gray-700 border border-gray-200">
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12">
                  <span class="text-sm font-bold capitalize">
                    {{ message.name ? message.name : "" }}
                    <span class="bg-green-600 text-white px-2 py-1 rounded-sm text-xs mx-1 capitalize">
                      {{ message.userType.toLowerCase() }}
                    </span>
                  </span>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12">
                  <span class="text-sm">{{ message.description }}</span>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12">
                  <span class="text-xs text-gray-500">{{ dateFormat(message.createdAt) }} | {{ message.statusLabel }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4" v-if="messages.length === 0">
            <div class="col-span-11 mx-auto rounded-md bg-gray-50 my-2 text-gray-700 p-4 text-center border border-gray-200">
              <span class="text-xs font-bold">No messages yet</span>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4 my-2" v-if="mode === 'TOP_MESSAGE'">
        <div
          class="col-span-12 py-2 rounded-md border border-gray-200 bg-gray-50 my-2 text-gray-700"
          v-if="messages.length > 0"
        >
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12">
                  <span class="text-sm font-bold capitalize">
                    {{ messages[0].user.fullName.toLowerCase() }}
                    <span class="bg-green-600 text-white px-2 py-1 rounded-sm text-xs capitalize">
                      {{ messages[0].userType.toLowerCase() }}
                    </span>
                  </span>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12">
                  <span class="text-sm">{{ messages[0].description }}</span>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12">
                  <span class="text-xs text-gray-500">{{ dateFormat(messages[0].createdAt) }} | {{ messages[0].statusLabel }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { dateFormat } from "@/commons/composables/utilities.ts";
import { useConfigurationsStore } from "../../../stores";

interface Message {
  id: string
  name?: string
  description: string
  userType: string
  statusLabel: string
  createdAt: string
  user: {
    fullName: string
  }
}

interface Props {
  task: {
    id: string
  }
  mode: string
}

const props = defineProps<Props>()

const store = useConfigurationsStore();
const loading = ref(true)
const messages = ref<Message[]>([])

onMounted(() => {
  if (props.task && props.task.id) {
    store.fetchInsolvencyTaskMessages(props.task.id);
  }
})

watch(
  () => store.insolvencyTaskMessages,
  (data) => {
    if (data) {
      loading.value = false
      messages.value = data
    }
  }
)
</script>
